export const paths = {
  studio: '/',
  history: '/history',
} as const;

/** `?report=paint-spec` on the studio page opens the paint specification report. */
export const REPORT_PARAM = 'report';
export const PAINT_SPEC_REPORT = 'paint-spec';
